let standardProperties = {
  id: "",
  x: 0,
  y: 0,
  z: 0,
  opacity: 1,
  transform: "none",
  // These should be set on creation
  width: 0,
  height: 0,
  name: "",
  type: "",
};

export function getStandardProperties() {
  return {
    ...standardProperties,
    id: createRandomId(),
  };
}

export function createRandomId() {
  // Create an 10 hexadecimal character random string
  return Math.random().toString(16).substr(2, 10);
}
